import GroupObject from "../objects/group"
import Calc from "@/common/util/calculator"
import BaseFixmethod from "@/signomatic/app/fixmethods/base"
import CircleObject from "@/signomatic/app/objects/circle"
import ImageObject from "@/signomatic/app/objects/image"
import RectObject from "@/signomatic/app/objects/rect"

export default class BallChainFixmethod extends BaseFixmethod {
  get visualPadding() {
    return { top: Calc.mmToPx(12), bottom: 0, left: 0, right: 0 }
  }

  topDrawable() {
    const { widthPx, heightPx } = this.state
    const items = []
    const outerWidth = 1 / this.drawables.scale
    const holeStroke = "#aaa"
    const holeFill = "#F5F7F6"
    const positions = this.positions()
    const holeRadius = Calc.mmToPx(1.75)
    const holeTop = positions[0].top

    const holeLeft = positions[0].left || 0

    items.push(
      new CircleObject({
        radius: holeRadius,
        left: holeLeft,
        top: holeTop,
        stroke: holeStroke,
        strokeWidth: outerWidth,
        fill: holeFill,
      }).addClass("hang")
    )

    // stretch
    items.push(
      new CircleObject({
        radius: holeRadius,
        left: widthPx - holeLeft,
        top: heightPx - holeTop,
        strokeWidth: outerWidth,
        stroke: "transparent",
        fill: "transparent",
      })
    )

    return [
      new GroupObject(items, {
        left: 0,
        top: 0,
        width: widthPx,
        height: heightPx,
      }),
      this.topKeyringDrawable()[0],
    ]
  }

  topKeyringDrawable() {
    const { widthPx, heightPx } = this.state
    const items = []
    const positions = this.positions()
    const holeTop = positions[0].top
    const ballChainHeight = Calc.mmToPx(22)
    const ballChainWidth = Calc.mmToPx(12)
    const frontImg = this.image("ball_chain_front.png")

    const left = (positions[0].left || 0) + Calc.mmToPx(4.3)
    const top = holeTop - Calc.mmToPx(20)

    if (frontImg) {
      items.push(
        new ImageObject(frontImg, {
          left,
          top,
          scaleX: (ballChainWidth || 0) / (frontImg.naturalWidth || frontImg.width),
          scaleY: (ballChainHeight || 0) / (frontImg.naturalHeight || frontImg.height),
        }).addClass("preview")
      )
      items.push(
        new RectObject({
          fill: "transparent",
          left: widthPx - left,
          top: heightPx - holeTop,
          width: ballChainWidth,
          height: ballChainHeight,
        }).addClass("preview")
      )
    }

    return [
      new GroupObject(items, {
        left: 0,
        top: 0,
        width: ballChainWidth,
        height: ballChainHeight,
      }),
    ]
  }

  bottomDrawable() {
    const { widthPx, heightPx } = this.state
    const items = []
    const positions = this.positions()
    const holeTop = positions[0].top
    const ballChainHeight = Calc.mmToPx(21)
    const ballChainWidth = Calc.mmToPx(8.5)
    const backImg = this.image("ball_chain_back.png")

    const left = (positions[0].left || 0) - Calc.mmToPx(2.4)
    const top = holeTop - Calc.mmToPx(20.7)

    if (backImg) {
      items.push(
        new ImageObject(backImg, {
          left,
          top,
          scaleX: (ballChainWidth || 0) / (backImg.naturalWidth || backImg.width),
          scaleY: (ballChainHeight || 0) / (backImg.naturalHeight || backImg.height),
        }).addClass("preview")
      )
      items.push(
        new RectObject({
          fill: "transparent",
          left: widthPx - left,
          top: heightPx - holeTop,
          width: ballChainWidth,
          height: ballChainHeight,
        }).addClass("preview")
      )
    }

    return new GroupObject(items, {
      left: 0,
      top: 0,
      width: ballChainWidth,
      height: ballChainHeight,
    })
  }

  protected imagePaths() {
    return ["/images/signomatic/fix_methods/ball_chain_front.png", "/images/signomatic/fix_methods/ball_chain_back.png"]
  }

  private positions() {
    const { widthPx, shape } = this.state
    const pos = []

    const diameter = Calc.mmToPx(3.5)
    const center = widthPx / 2

    const top = Calc.mmToPx(4)
    const holeLeft = ["rect", "round"].includes(shape)

    pos.push({ left: holeLeft ? top : center, top, diameter })

    return pos
  }
}
